<template>
  <div class="personal" :style="{'padding': !editing ? '30px 0': '0'}">
    <div class="app_title" v-if="!editing">个人中心</div>
    <div class="bd_y" v-if="!editing"></div>
    <div class="main-right" v-if="!editing">
      <div class="main-right-item">
        <h3><i class="iconfont iconkongzhitai_farenxinxi"></i>基础信息</h3>
        <el-form label-width="180px">
          <el-form-item label="账号：">
            <el-input v-model="user.account" disabled></el-input>
          </el-form-item>
          <el-form-item label="手机号码：">
            <el-input v-model="phone" disabled></el-input>
          </el-form-item>
        </el-form>
        <button class="commonBtn editBtn" @click.prevent="edit">修改手机号</button>
      </div>
      <div class="main-right-item second"> <!-- v-if="baseInfo.apiAccount"-->
        <h3>
          <i class="iconfont icongerenzhongxin_yonghupeizhi"></i>应用管理
          <el-tooltip class="item" effect="dark" placement="top">
            <div style="width: 200px" slot="content">当存在多种业务模式时，建议使用不同的应用进行区分，当前最多添加10个应用，不同应用之间互不干涉。</div>
            <i class="app-icon el-icon-warning-outline"></i>
          </el-tooltip>
        </h3>
        <div class="application-box" v-for="(item, index) in baseInfo" :key="index">
          <div class="box-top">
            <div class="top-left">
              <span v-if="!item.editDisabled">{{item.appName}}</span>
              <div v-else style="display: flex;align-items: center;">
                <el-input v-model="item.appName" style="width: 200px;"/>
                <i style="color: #E60000;cursor: pointer;margin-left:5px;font-size:16px" class="el-icon-check" @click="editName(index, item)"></i>
              </div>
              <i v-if="!item.editDisabled" style="color: #E60000;cursor: pointer;margin-left:5px" class="el-icon-edit" @click="editName(index)"></i>
            </div>
            <div class="top-right" @click="applicationTab(index)"><i style="position: relative;" :class="[item.isShow ? 'el-icon-arrow-down':'el-icon-arrow-up']"></i></div>
          </div>
          <transition>
            <div class="box-content" v-show="item.isShow">
              <div class="box-item">
                <div>
                  <span class="item-label">apiAccount：</span>
                  <span class="item-value">{{item.apiAccount}}</span>
                </div>
                <div class="icon-chakan" @click="showDetail(index, item, 1)" v-if="item.apiAccount"><i style="font-size: 16px;" :class="['iconfont', item.accountShow ? 'iconchakan1' : 'iconshoujihaoyincang']"></i></div>
              </div>
              <div class="box-item">
                <div>
                  <span class="item-label">privateKey：</span>
                  <span class="item-value">{{item.privateKey}}</span>
                </div>
                <div class="icon-chakan" @click="showDetail(index, item, 2)" v-if="item.privateKey"><i style="font-size: 16px;" :class="['iconfont', item.keyShow ? 'iconchakan1' : 'iconshoujihaoyincang']"></i></div>
              </div>
              <div class="box-item">
                <div>
                  <span class="item-label">来源代码：</span>
                  <span class="item-value">{{item.orderCode}}</span>
                </div>
              </div>
              <div class="box-item">
                <div>
                  <span class="item-label">来源名称：</span>
                  <span class="item-value">{{item.orderSource}}</span>
                </div>
              </div>
            </div>
          </transition>
        </div>
        <el-button style="margin-top:20px;color:#E60000" icon="el-icon-plus" @click.prevent="AddApp()" v-if="this.baseInfo.length<10">添加应用</el-button>
      </div>
    </div>
    <div class="main-right-edit" v-if="editing">
      <div class="main-right-edit-header">
        <span
          class="typeItem"
          :class="{ activeType: type === 1 }"
          @click="changeType(1)"
          >手机号码</span
        >
        <!-- <span class="typeItem" :class="{activeType:type === 2}" @click="changeType(2)">邮箱账号</span> -->
      </div>
      <div class="main-right-edit-content" v-show="type === 1">
        <el-form label-width="210px">
          <el-form-item label="新手机号码：">
            <el-input
              v-model="editForm.phone"
              placeholder="请输入新手机号码"
              maxlength="11"
            ></el-input>
          </el-form-item>
          <el-form-item label="验证码：" class="phoneCodeItem">
            <el-input
              v-model="editForm.captcha"
              placeholder="请输入验证码"
              maxlength="8"
            ></el-input>
            <button
              class="sendcodeBtn commonBtn"
              @click.prevent="sendCodeBefore"
              :disabled="isSendCode"
            >
              <span v-if="!isSendCode">发送</span>
              <span v-else>{{ time }}秒</span>
            </button>
          </el-form-item>
        </el-form>
      </div>
      <div class="main-right-edit-content" v-show="type === 2">
        <el-form label-width="210px">
          <el-form-item label="邮箱："> 
            <el-input disabled></el-input>
          </el-form-item>
          <el-form-item label="验证码：">
            <el-input disabled></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn-group">
        <button class="commonBtn bindphone" @click.prevent="editPhone">
          修改
        </button>
        <button class="commonBtn cancel" @click.prevent="cancel">取消</button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { VALIDATION } from '@/constants/rules'
import { RESPONSE_SUCCESS } from '@/constants'
import debounce from 'lodash/debounce'
export default {
  name: 'PersonalCenter',
  data() {
    return {
      editing: false,
      baseInfo: [],
      editForm: {
        captcha: '',
        phone: '',
      },
      isSendCode: false,
      time: 60,
      codeTimer: null,
      type: 1, //个人中心修改type
      captcha:"", //腾讯验证码
      phone: ''
    }
  },
  mounted() {
    this.getCertificationInfo()
    this.getAppList()
    this.initTencentCaptcha();
  },
  computed: {
    ...mapGetters(['user']),
  },
  destroyed() {
    clearInterval(this.codeTimer)
  },
  methods: {
    showDetail: debounce(async function (index, item, type) {
      if (type === 1) {
        if (!item.accountShow) {
          this.$set(this.baseInfo[index], 'accountShow', true)
          if (item.newApiAccount) {
            const temp = this.baseInfo[index].newApiAccount
            this.baseInfo[index].newApiAccount = this.baseInfo[index].apiAccount
            this.baseInfo[index].apiAccount = temp
          } else {
            const formData = new FormData()
            formData.append('id', item.id)
            const res = await this.$API.appDetails(formData)
            if (res.code === RESPONSE_SUCCESS) {
              this.baseInfo[index].newApiAccount = this.baseInfo[index].apiAccount
              this.baseInfo[index].apiAccount = res.data.apiAccount
            } else {
              this.$message.error(res.msg)
            }
          }
        } else {
          this.$set(this.baseInfo[index], 'accountShow', false)
          const temp = this.baseInfo[index].newApiAccount
          this.baseInfo[index].newApiAccount = this.baseInfo[index].apiAccount
          this.baseInfo[index].apiAccount = temp
        }
      } else {
        if (!item.keyShow) {
          this.$set(this.baseInfo[index], 'keyShow', true)
          if (item.newPrivateKey) {
            const temp = this.baseInfo[index].newPrivateKey
            this.baseInfo[index].newPrivateKey = this.baseInfo[index].privateKey
            this.baseInfo[index].privateKey = temp
          } else {
            const formData = new FormData()
            formData.append('id', item.id)
            const res = await this.$API.appDetails(formData)
            if (res.code === RESPONSE_SUCCESS) {
              this.baseInfo[index].newPrivateKey = this.baseInfo[index].privateKey
              this.baseInfo[index].privateKey = res.data.privateKey
            } else {
              this.$message.error(res.msg)
            }
          }
        } else {
          this.$set(this.baseInfo[index], 'keyShow', false)
          const temp = this.baseInfo[index].newPrivateKey
          this.baseInfo[index].newPrivateKey = this.baseInfo[index].privateKey
          this.baseInfo[index].privateKey = temp
        }
      }
    }, 500),
    async getAppList(id) {
      const res = await this.$API.appList()
      if (res.code === RESPONSE_SUCCESS) {
        if (this.baseInfo.length && res.data.length) {
          if (!id) {
            this.baseInfo.push(res.data[res.data.length - 1])
            this.$set(this.baseInfo[this.baseInfo.length - 1], 'isShow', false)
          } else {
            const index = this.baseInfo.findIndex(v => v.id === id)
            const temp = res.data.find(v => v.id === id)
            this.baseInfo[index].appName = temp.appName
          }
        } else {
          this.baseInfo = res.data
          this.$set(this.baseInfo[0], 'isShow', true)
        }
      }
    },
    editName(index, item) {
      if (this.baseInfo[index].editDisabled) {
        this.$set(this.baseInfo[index], 'editDisabled', false)
        this.AddApp(item.id, item.appName)
      } else {
        this.$set(this.baseInfo[index], 'editDisabled', true)
      }
    },
    async AddApp(id = null, appName = null) {
      const index = this.baseInfo.length + 1
      const params = { appName: appName ? appName : '应用' + index, userId: this.user.id }
      if (id) {
        params['appId'] = id
      }
      const res = await this.$API.addApp(params)
      if (res.code === RESPONSE_SUCCESS) {
        this.$message.success(res.msg)
        // 重新获取应用列表
        this.getAppList(id)
      } else {
        this.$message.error(res.msg)
      }
    },
    async applicationTab(index) {
      if (this.baseInfo[index].isShow) {
        this.$set(this.baseInfo[index], 'isShow', false)
      } else {
        this.$set(this.baseInfo[index], 'isShow', true)
      }
    },
    //修改
    edit() {
      this.editing = true
    },
    // 初始化tx验证码
    initTencentCaptcha() {
      // 生成实例对象
      this.captcha = new window.TencentCaptcha('2034935631', this.tencentCaptchaCallback);
    },
    // 验证码回调
    async tencentCaptchaCallback(res) {
      // 验证成功，返回对象
      if (res.ret === 0) {
        // 定义参数：票据 随机字符串
        const customParams = {
          ticket: res.ticket,
          randstr: res.randstr
        }
        // 调用登陆
        this.sendCode(customParams)
        
        return res
      }
      // 验证不成功
      return null
    },
    /**
     * @description 修改手机号发送验证码
     */
    sendCode({ticket,randstr}) {
      let params = {
        phone: this.editForm.phone,
        type: 'change_phone',
        ticket,
        randstr
      }
      this.$API.sendMessage(params).then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          this.isSendCode = true
          clearInterval(this.codeTimer)
          this.codeTimer = setInterval(() => {
            this.time--
            if (this.time === 0) {
              this.isSendCode = false
              this.time = 60
            }
          }, 1000)
          this.$message.success('获取手机验证码成功')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    sendCodeBefore(){
     if (!this.editForm.phone) {
        return this.$message.warning('请输入手机号')
      }
      if (!VALIDATION.phoneNumber.value.test(this.editForm.phone)) {
        return this.$message.warning('请输入正确的手机号')
      }
        this.captcha.show()
    },
    //修改手机号
    editPhone() {
      if (!this.editForm.phone || !this.editForm.phone) {
        return this.$message.warning('请输入手机号和验证码')
      }
      this.$API.changePhone(this.editForm).then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          this.$message.success('修改手机号成功')
          this.getCertificationInfo()
          this.cancel()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    //取消
    cancel() {
      this.editing = false
      this.editForm.phone = ''
      this.editForm.captcha = ''
    },
    /**
     * @description 查询认证信息
     */
    getCertificationInfo() {
      this.$API.getCertificationInfo().then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          this.phone = res.data.userPhone
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.personal {
  .app_title {
      font-size: 18px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
      color: #2b2b2b;
      margin-bottom: 18px;
      margin-left: 30px;
    }
    .bd_y {
      // width: 947px;
      height: 1px;
      background: #D9D9D9;
      margin-bottom: 22px;
    }
    .main-right {
      flex: 1;
      background: #fff;
      box-sizing: border-box;
      padding: 0 30px;
      overflow: auto;
      .main-right-item {
        .app-icon {
          margin-left: 5px;
          font-size: 16px;
        }
        .app-icon:hover {
          cursor: pointer;
          color: #E60000;
        }
        h3 {
          font-size: 22px;
          color: #2b2d42;
          line-height: 22px;
          margin-bottom: 20px;
          .iconfont {
            color: $theme-color;
            font-size: 24px;
            margin-right: 16px;
          }
        }
        &.second {
          margin-top: 50px;
        }
        .application-box {
          border: 1px solid #D9D9D9;
          border-radius: 3px;
          margin: 10px 0;
          .box-top {
            padding: 0 30px;
            display: flex;
            justify-content: space-between;
            background-color: #f4f5f7;
            height: 48px;
            line-height: 48px;
            .top-left {
              font-size: 14px;
              font-weight: 600;
              font-family: PingFangSC, PingFangSC-Medium;
            }
            .top-right {
              font-size: 16px;
              flex: 1;
              text-align: right;
            }
            .top-right:hover {
              cursor: pointer;
              color: #E60000;
            }
          }
          .box-content {
            padding: 20px 30px;
            // transition-property: display;
            // transition-duration: 900ms;
            // transition-delay: 100ms;
            // transition-timing-function: ease-out;
            .box-item {
              height: 38px;
              line-height: 38px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .item-label, .item-value {
                font-size: 14px;
                font-weight: 500;
              }
              .icon-chakan:hover {
                cursor: pointer;
              }
            }
          }
        }
      }
    }
    .main-right-edit {
      flex: 1;
      background: #fff;
      box-sizing: border-box;
      .main-right-edit-header {
        height: 71px;
        width: 100%;
        border-bottom: 1px solid $table-border-color;
        color: #2b2d42;
        font-weight: 900;
        box-sizing: border-box;
        font-size: 22px;
        line-height: 70px;
        padding-left: 30px;
        .typeItem {
          cursor: pointer;
          display: inline-block;
          &:last-of-type {
            margin-left: 50px;
          }
          &.activeType {
            color: $theme-color;
            border-bottom: 2px solid $theme-color;
          }
        }
      }
      .main-right-edit-content {
        padding-top: 50px;
      }
      .btn-group {
        margin-left: 464px;
      }
      .bindphone {
        width: 88px;
        height: 40px;
        background: $theme-color;
        font-size: 14px;
        color: #fff;
      }
      .cancel {
        width: 88px;
        height: 40px;
        background: #fff;
        border: 1px solid #b0b3b6;
        font-size: 14px;
        margin-left: 20px;
      }
    }
    .editBtn {
      width: 120px;
      height: 40px;
      background: $theme-color;
      color: #fff;
      margin-left: 180px;
      font-size: 14px;
    }
    .phoneCodeItem {
      position: relative;
      .sendcodeBtn {
        position: absolute;
        width: 60px;
        height: 32px;
        border-radius: 4px;
        font-size: 14px;
        right: 290px;
        top: 4px;
        border: 1px solid #c4c8cc;
      }
    }
  }
  .v-enter-active{
    animation: myAni 0.5s;
  }

  .v-leave-active{
    animation: myAni 0.5s reverse;
  }

  @keyframes myAni {
    from{
      transform: translateY(-20%);
      opacity: 0;
    }
    to{
      transform: translateY(0px);
      opacity: 1;
    }
  }
  .iconfont:hover {
    color: #E60000;
  }
</style>
